import React from "react";
import TableHeader from "../Common/TableHeader";
import { Link } from "react-router-dom";
import DeleteParentContact from "./DeleteParentContact";
import useStateCallback from "../../util/customHooks/useStateCallback";

function UserContacts({contactList, getParentContacts, countParentContacts}) {
    const [modal, setModal] = useStateCallback(false);

    const deleteParentContact = (e, item) => {
        setModal(false, () =>
          setModal(
            <DeleteParentContact
              tableID={item.id}
              g={getParentContacts}
              h={countParentContacts}
              isOpen={true}
            />
          )
        );
    };

    return (
        <>
        {modal}
            <TableHeader subtitle="List of all the contacts"/>
            <div className="table-responsive">
                <table className="table table-hover text-nowrap mg-b-0" id="second">
                    <thead>
                        <tr>
                            <th scope="col">No.</th>
                            <th scope="col"> Names</th>
                            <th scope="col"> Contact Number</th>
                            <th scope="col"> Actions</th>

                        </tr>
                    </thead>
                    <tbody>
                    {Array.isArray(contactList) &&
                        contactList.map((item, key) => (
                        <tr key={key}>
                            <th scope="row">{key + 1}</th>
                            <td>{item.contact?.full_name}</td>
                            <td>{item.contact?.username}</td>
                            <td>
                                                                                <div className="dropdown">
                                                                                    <Link
                                                                                    to="#"
                                                                                    className="dropdown-toggle"
                                                                                    data-toggle="dropdown"
                                                                                    aria-expanded="false"
                                                                                    >
                                                                                    <span className="flaticon-more-button-of-three-dots"></span>
                                                                                    </Link>
                                                                                    <div className="dropdown-menu dropdown-menu-right" style={{overflowY:"auto", maxHeight:"150px"}}>
                                                                                        
                                                                                        <Link
                                                                                        className="dropdown-item"
                                                                                        to="#"
                                                                                        onClick={(e) => deleteParentContact(e, item)}
                                                                                        >
                                                                                        <i className="fa fa-trash mr-1" style={{ color: "red" }}></i>
                                                                                        Delete Contact
                                                                                        </Link>
                                                                                        
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                        </tr>
                    ))}
                    {contactList === "404" && (
                        <tr>
                            <td colSpan="3" style={{ textAlign: "center" }}>
                            No contacts added to this parent yet.
                            </td>
                        </tr>
                    )}
                    </tbody>
                </table>
            </div>
        
        </>
        
    );
}

export default UserContacts;
